import { CloudOff } from "lucide-react";
import type { ReactNode } from "react";
import { OFFLINE_WRITE_REASON, useCanWrite, useConnectivity } from "../lib/connectivity";

/** Persistent, app-wide connectivity banner. Its id is referenced by every disabled write control. */
export function OfflineBanner() {
  const state = useConnectivity();
  const writable = state.browserOnline && state.serverReachable;
  return (
    <div className="offline-slot" aria-live="polite">
      {!writable ? (
        <div className="offline-banner" id="offline-banner" role="status">
          <CloudOff size={20} aria-hidden="true" />
          <p>
            <strong>{state.browserOnline ? "Can't reach Supperkeep." : "You're offline."}</strong>{" "}
            Showing what was saved on this device. Changes are turned off until you reconnect.
          </p>
        </div>
      ) : null}
    </div>
  );
}

/**
 * Shared write guard: disables every native control inside while offline, with the reason
 * announced next to the controls.
 */
export function WriteGuard({ children, className }: { children: ReactNode; className?: string }) {
  const canWrite = useCanWrite();
  return (
    <fieldset className={["write-guard", className ?? ""].join(" ")} disabled={!canWrite} aria-describedby={!canWrite ? "offline-banner" : undefined}>
      {!canWrite ? (
        <p className="write-guard__note">
          <CloudOff size={16} aria-hidden="true" /> {OFFLINE_WRITE_REASON}
        </p>
      ) : null}
      {children}
    </fieldset>
  );
}
